import React from 'react'
import { graphql, StaticQuery } from 'gatsby'
import Img from 'gatsby-image'
import PropTypes from 'prop-types'
import Header from '../Header'
import MobileBottomImages from '../MobileBottomImages'

const AboutPageTemplate = ({
  meta_title,
  meta_description,
  about,
}) => (
  <StaticQuery
    query={graphql`
      query AboutImgQuery {
        image1: file(
          relativePath: {
            eq: "image-unternehmen_01.png"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 500, maxHeight: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
        image2: file(
          relativePath: {
            eq: "image-unternehmen_02.jpg"
          }
        ) {
          childImageSharp {
            fluid(maxWidth: 500, maxHeight: 500) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `}
    render={(data) => (
      <div>
        <Header
          meta_title={meta_title}
          meta_description={meta_description}
          heading={about.heading}
          breadcrumb='HOME > UNTERNEHMEN'
        />
        <section className='section section--gradient without-vertical-padding'>
          <div className='container anthracite-text'>
            <div className='section without-vertical-padding'>
              <div className='columns is-desktop'>
                <div className='column is-three-quarters-tablet is-half-desktop'>
                  <div className='content'>
                    <h3 className='light'>{about.description}</h3>
                    <p className='anthracite-text'>
                      <span className='bold'>{about.left_text_strong}</span>
                    </p>
                    <p className='anthracite-text'>
                      {about.left_text_1}
                    </p>
                    <p className='anthracite-text'>
                      {about.left_text_2}
                    </p>
                    <p className='anthracite-text'>
                      {about.left_text_3}
                    </p>
                  </div>
                </div>
                <div className='column is-hidden-touch'>
                  <Img fluid={data.image1.childImageSharp.fluid} alt='' />
                </div>
              </div>
            </div>
            <div className='section without-vertical-padding'>
              <div className='columns is-desktop'>
                <div className='column is-hidden-touch'>
                  <Img fluid={data.image2.childImageSharp.fluid} alt='' />
                </div>
                <div className='column is-three-quarters-tablet is-half-desktop'>
                  <div className='content'>
                    <p className='anthracite-text'>
                      <span className='bold'>{about.right_text_strong}</span>{' '}
                    </p>
                    <div>
                      <ul>
                        {about.right_text_list.map(item => (
                          <li key={item.title}>{item.title}</li>
                        ))}
                      </ul>
                    </div>
                    <p>
                      <br />{about.right_text_subline}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <MobileBottomImages image1={data.image1} image2={data.image2} />
          </div>
        </section>
      </div>
    )}
  />
)

AboutPageTemplate.propTypes = {
  meta_title: PropTypes.string,
  meta_description: PropTypes.string,
  about: PropTypes.shape({
    heading: PropTypes.string,
    description: PropTypes.string,
    left_text_strong: PropTypes.string,
    left_text_1: PropTypes.string,
    left_text_2: PropTypes.string,
    left_text_3: PropTypes.string,
    right_text_strong: PropTypes.string,
    right_text_list: PropTypes.array,
    right_text_subline: PropTypes.string,
  }),
}

export default AboutPageTemplate
